<script>
    import { metaInfo } from "@/core/MetaInfo";
    import CertificatesInfo from "@/components/CertificatesInfo";

    export default {
        name: "Certificates",
        components: { CertificatesInfo },
        metaInfo() {
            return metaInfo.getMeta("certificates");
        },
    };
</script>

<template>
    <certificates-info
        name="Madrobots"
        url="madrobots.ru"
        type="v1"
        size="md"
        additional-icon="external"
        :catalog-path="{ name: 'Catalog' }"
    ></certificates-info>
</template>

<style lang="scss">
    @import "~@madrobots/assets/sass/typography.scss";

    .certificates {
        padding: 24px 0 60px;
        background-color: #e3e9f0;
        @include bp($bp-desktop-sm) {
            padding-top: 56px;
        }
    }
</style>
